// extracted by mini-css-extract-plugin
module.exports = {"linkActive":"_1yJR9","icon":"_1UJnU","bubble":"_3HUDA","heart":"XzVf_"};